<template>
    <fieldset>
        <legend class="shop__fieldgroup-title">{{Strings['Shop.Product']}}</legend>        
        <div class="shop__error-message-block" v-if="ErrorType === 'OverMaxAmount'">
            <v-runtime-template :template="Strings['Shop.Errors.OverMaxAmountHL']" />
        </div>        
        <div class="shop__error-message-block" v-else-if="ErrorType === 'ZipCodeInvalid'">
            {{Strings['Shop.Errors.ZipCodeInvalid']}}
        </div>
        <div class="shop__error-message-block" v-else-if="ErrorType === 'Unexpected'">
            {{Strings['Shop.Errors.PricesCantBeCalculated']}}
        </div>
        <div class="shop__materials">
            <HeizoelMaterial v-for="(material, index) in AvailableMaterials" :key="material.id" :material="material" :showPrice="PricesAvailable" :isSelected="value === material" @input="setMaterial" :col="index+1"></HeizoelMaterial>
        </div>
        <div class="shop__price-info" v-show="PricesAvailable">
            <v-runtime-template :template="PriceInfoText" />
        </div>
    </fieldset>
</template>

<script>
    import { mapState } from 'vuex';
    import HeizoelMaterial from './HeizoelMaterial';
    import Price from '@/models/Price';
    import Material from '@/models/Material';
    import VRuntimeTemplate from "v-runtime-template";
    import Transaction from '@/models/Transaction'
    import { PriceRequestOutcomes } from '@/utils/constants';

    export default {
        props: {
            value: Object
        },
        computed: {
            ...mapState([
                'Strings',
                'PriceInfoText',
                'MaxAmountTotal',
                'DirectPriceActivated',
                'PriceCalculationOutcome'
            ]),
            AvailableMaterials() {
                return Material.query().orderBy('id').get();
            },
            PricesAvailable() {
                return Price.query().count() > 0;
            },
            CurrentTransaction() {
                return Transaction.query().with(['positions']).first();
            },
            AmountTooHigh() {
                return this.CurrentTransaction.totalAmount > this.MaxAmountTotal;
            },
            ErrorType() {
                if (this.DirectPriceActivated && this.CurrentTransaction.totalAmount > this.MaxAmountTotal)
                    return "OverMaxAmount";
                if (this.PriceCalculationOutcome != null && this.PriceCalculationOutcome == PriceRequestOutcomes.ZipCodeInvalid)
                    return "ZipCodeInvalid";
                if (this.PriceCalculationOutcome != null && this.PriceCalculationOutcome == PriceRequestOutcomes.Unexpected)
                    return "Unexpected";
                return null;
            }
        },
        methods: {
            setMaterial(material) {
                this.$emit('input', material);
            }
        },
        components: {
            HeizoelMaterial,
            VRuntimeTemplate
        }
    };
</script>